// src/utils/updateMeta.js

const setOrCreateMeta = (selector, attrName, attrValue, contentValue) => {
  if (!contentValue) return;
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attrName, attrValue);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', contentValue);
};

const setOrCreateLink = (rel, href) => {
  if (!href) return;

  let tag = document.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', href);
};

export const updateMeta = (meta) => {
  const {
    title,
    description,
    keywords,
    canonical,
    robots = 'index,follow',
    author = 'MAJ Technology',
    ogTitle,
    ogDescription,
    ogImage,
    ogUrl,
    twitterCard = 'summary_large_image',
  } = meta;

  // Title
  if (title) document.title = title;
  // Basic meta
  setOrCreateMeta('meta[name="description"]', 'name', 'description', description);
  setOrCreateMeta('meta[name="keywords"]', 'name', 'keywords', keywords);
  setOrCreateMeta('meta[name="robots"]', 'name', 'robots', robots);
  setOrCreateMeta('meta[name="author"]', 'name', 'author', author);

  // Canonical
  setOrCreateLink('canonical', canonical);

  // Open Graph
  setOrCreateMeta('meta[property="og:title"]', 'property', 'og:title', ogTitle || title);
  setOrCreateMeta('meta[property="og:description"]', 'property', 'og:description', ogDescription || description);
  setOrCreateMeta('meta[property="og:image"]', 'property', 'og:image', ogImage);
  setOrCreateMeta('meta[property="og:url"]', 'property', 'og:url', ogUrl || canonical);
  setOrCreateMeta('meta[property="og:type"]', 'property', 'og:type', 'website');

  // Twitter
  setOrCreateMeta('meta[name="twitter:card"]', 'name', 'twitter:card', twitterCard);
  setOrCreateMeta('meta[name="twitter:title"]', 'name', 'twitter:title', ogTitle || title);
  setOrCreateMeta('meta[name="twitter:description"]', 'name', 'twitter:description', ogDescription || description);
  setOrCreateMeta('meta[name="twitter:image"]', 'name', 'twitter:image', ogImage);
};
